export type Nullable<T> = T | null;
export type Maybe<T> = T | undefined;
export type SingleOrArray<T> = T | T[];

export enum AlertSeverity {
  Error = "error",
  Info = "info",
  Warning = "warning",
}

export enum AsyncOperationStatus {
  Error = "error",
  Pending = "pending",
  Success = "success",
}

// Accepts an object type and makes every property value Nullable
export type NullableValues<T extends object> = {
  [K in keyof T]: Nullable<T[K]>;
};

// Accept a type (`T`) and make the given keys (`K`) required. Example:
// type GuestUser = { email?: string; id: string; name?: string; };
// type User = MakeRequired<GuestUser, "email">;
// User: { email: string; id: string; name?: string; };
// A selective variation on the built-in `Required` type
export type MakeRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

// Accept a type T and replace the given keys K with the key/value pairs in V
export type ReplaceProp<
  T,
  K extends keyof T,
  V extends { [P in K]?: unknown },
> = Omit<T, K> & V;

// This predicate is too generic to give a more specific function definition
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const isFunction = (value: unknown): value is Function =>
  typeof value === "function";

export enum YesNo {
  Yes = "yes",
  No = "no",
}

export type Positive = number & { __brand: "positive" };

export const isPositive = (value?: number): value is Positive =>
  typeof value === "number" && !isNaN(value) && value > 0;
